import * as React from 'react';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Title from './Title';
import Chart from '../Chart/Chart';
import Logo from '../logo/logo';
import useMainContainer from './MainContainer.services';

const fixedHeightPaper = {
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  height: 140,
};

const StatTile = ({ title, value, caption }) => (
  <Paper sx={fixedHeightPaper}>
    <Title>{title}</Title>
    <Typography component="p" variant="h4">
      {value}
    </Typography>
    <Typography color="text.secondary" sx={{ flex: 1 }}>
      {caption}
    </Typography>
  </Paper>
);

export default function MainContainer() {

  const { loading, stats, getStats } = useMainContainer();

  React.useEffect(() => {
    getStats();
  }, []);

  return (
    <Box
      component="main"
      sx={{
        backgroundColor: (theme) =>
          theme.palette.mode === 'light'
            ? theme.palette.grey[100]
            : theme.palette.grey[900],
        flexGrow: 1,
        height: '100vh',
        overflow: 'auto',
      }}
    >
      <Toolbar />
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        { loading ? <Logo /> : (
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <Title>Capacitaciones en {stats.year}</Title>
                <Typography component="p" variant="h4">
                  {stats.totalTrainingsInYear}
                </Typography>
              </Paper>
            </Grid>

            <Grid item xs={12} sm={4}>
              <StatTile
                title="Pasadas"
                value={stats.pastTrainings}
                caption={`${stats.pastTrainingsParticipants} participantes`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatTile
                title="Activas"
                value={stats.activeTrainings}
                caption={`${stats.activeTrainingsParticipants} participantes`}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <StatTile
                title="Próximas"
                value={stats.futureTrainings}
                caption={`${stats.futureTrainingsParticipants} participantes`}
              />
            </Grid>

            <Grid item xs={12}>
              <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column', height: 320 }}>
                <Chart title={`Capacitaciones por mes (${stats.year})`} data={stats.trainingsByMonth} />
              </Paper>
            </Grid>
          </Grid>
        ) }
      </Container>
    </Box>
  );
}
